import { IDonor } from '../donor';

export interface ICompatibleDonorForPreselect extends IDonor {
    isAccepted: boolean,
    isReEvalNeeded: boolean,
    singleEpletMmDr: number,
    singleEpletMmDq: number,
    singleEpletMmDqLow: number,
    totalEpletMmDr: number,
    totalEpletMmDq: number,
    surgeonContactIsDeleted: boolean,
    surgeonContactFullName: string,
    surgeonContactEmail: string,
    daysInNkr: number,
    pairMatchPower: number,
    storedPairMatchPower: number,
    centerState: string
}